import React from 'react';
import { Link } from 'react-router-dom';


export default function FAQPage(){
  return (
    <div>
      <div className="container" style={{paddingTop:110}}>
        <section id="faq" className="section" data-bg="teal">
          <div style={{textAlign:'center',marginBottom:22}}>
            <span className="badge"><i className="fi fi-rr-interrogation" style={{fontSize:14,opacity:.9}}></i> FAQ'S</span>
            <h1 style={{fontSize:'clamp(28px,4vw,46px)',margin:'10px 0'}}>Frequently Asked Questions</h1>
            <p className="subtitle" style={{marginTop:0}}>Find quick answers to the most common support questions</p>
          </div>
          <div className="grid grid-2">
            <div className="card glass more-quest" style={{display:'flex',flexDirection:'column',gap:5,alignItems:'center'}}>
              <div className="shine"></div>
              <h3>Still Have Questions?</h3>
              <p className="dim">Still have questions? Feel free to get in touch with us today!</p>
              <Link className="btn btn-card" to="/contact">Ask A Question</Link>
            </div>
            <div>
              <details>
                <summary>What exactly does Promptera do?</summary>
                <p className="dim">Promptera helps you create, improve, save, and share AI prompts so your best work is easy to reuse.</p>
              </details>
              <details>
                <summary>Do I need to bring my own API key?</summary>
                <p className="dim">No. Your Free Trial includes credits for model usage, so you can start straight away; you can add your own key later if you prefer.</p>
              </details>
              <details>
                <summary>Which models does it support?</summary>
                <p className="dim">The Free Trial includes GPT-5 and lower-cost models. Gemini and DeepSeek support are planned for upcoming plans.</p>
              </details>
              <details>
                <summary>Do I need to be technical to use it?</summary>
                <p className="dim">No. If you can describe the result you want, you can create and improve prompts in Promptera.</p>
              </details>
              <details>
                <summary>What happens to my prompts—are they used for training?</summary>
                <p className="dim">No. Promptera does not use your prompts to train its own AI. Content is sent only to the AI provider needed to deliver the feature you choose, under that provider’s terms.</p>
              </details>
              <details>
                <summary>How is this different from just using a Google Doc or Notion?</summary>
                <p className="dim">Docs store text; Promptera helps you test prompts, compare results, keep version history, and share the versions that work.</p>
              </details>
              <details>
                <summary>What does it cost, and what&apos;s in the Free Trial?</summary>
                <p className="dim">The Free Trial is free and includes 500 credits, version control, collaboration, Prompt DNA, and multi-model testing. Standard is planned at €25 per month and is coming soon.</p>
              </details>
              <details>
                <summary>Can I invite my team?</summary>
                <p className="dim">Yes. Invite teammates to a shared workspace so you can create, review, and reuse prompts together.</p>
              </details>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
